import React from 'react';
import {
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
} from '@mui/material';

/**
 * Props that we do not want to include with DialogContent.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type DialogContentBlockedProps = keyof Pick<MuiDialogContentProps, 'dividers'>;

export type DialogContentProps = Omit<
  MuiDialogContentProps,
  DialogContentBlockedProps
> & {
  /**
   * @deprecated Unsupported prop: Use `showDivider` on DialogTitle instead. This prop is not supported in Unify design guidelines and will be removed in the next major.
   * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this prop.
   */
  dividers?: MuiDialogContentProps['dividers'];
};

export const DialogContent = React.forwardRef<HTMLElement, DialogContentProps>(
  function UnifyDialogContent(props, ref) {
    return <MuiDialogContent {...props} ref={ref} />;
  }
);
